import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79303f67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reserved-order-customer-details" }
const _hoisted_2 = { class: "customer-block-view" }
const _hoisted_3 = { class: "customer-block" }
const _hoisted_4 = { class: "customer-block-header" }
const _hoisted_5 = {
  key: 1,
  class: "d-flex",
  style: {"gap":"1rem"}
}
const _hoisted_6 = { class: "customer-data-row" }
const _hoisted_7 = { class: "first-item" }
const _hoisted_8 = { class: "customer-data-title" }
const _hoisted_9 = {
  key: 1,
  class: "customer-data-value"
}
const _hoisted_10 = { class: "second-item" }
const _hoisted_11 = { class: "customer-data-title" }
const _hoisted_12 = {
  key: 1,
  class: "customer-data-value"
}
const _hoisted_13 = { class: "customer-data-row" }
const _hoisted_14 = { class: "first-item" }
const _hoisted_15 = { class: "customer-data-title" }
const _hoisted_16 = {
  key: 1,
  class: "customer-data-value"
}
const _hoisted_17 = { class: "second-item" }
const _hoisted_18 = { class: "customer-data-title" }
const _hoisted_19 = {
  key: 1,
  class: "customer-data-email"
}
const _hoisted_20 = { class: "customer-block" }
const _hoisted_21 = { class: "customer-block-header" }
const _hoisted_22 = { class: "customer-data-row" }
const _hoisted_23 = { class: "fit-row" }
const _hoisted_24 = { class: "customer-data-title" }
const _hoisted_25 = { class: "customer-data-value" }
const _hoisted_26 = { class: "order-status" }
const _hoisted_27 = { class: "customer-data-title" }
const _hoisted_28 = { class: "customer-data-row" }
const _hoisted_29 = { class: "fit-row" }
const _hoisted_30 = { class: "customer-data-title" }
const _hoisted_31 = { class: "customer-data-value" }
const _hoisted_32 = { class: "fit-row arrivalConfirmation" }
const _hoisted_33 = { class: "customer-data-title" }
const _hoisted_34 = {
  key: 4,
  class: "arrivalConfirmationPoppup"
}
const _hoisted_35 = { class: "arrived-title" }
const _hoisted_36 = { class: "ArrivalConfirmationRowActions" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-check fs-10 pr-8" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-delete-cross fs-10 pr-8" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-check fs-10 pr-8" }, null, -1))
const _hoisted_40 = { class: "customer-data-row" }
const _hoisted_41 = { class: "fit-row" }
const _hoisted_42 = { class: "customer-data-title" }
const _hoisted_43 = { class: "customer-data-value" }
const _hoisted_44 = { class: "fit-row" }
const _hoisted_45 = { class: "customer-data-title" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "customer-data-value" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-check fs-12 pr-8" })
], -1))
const _hoisted_47 = {
  key: 0,
  class: "customer-data-row"
}
const _hoisted_48 = { class: "fit-row" }
const _hoisted_49 = { class: "customer-data-title" }
const _hoisted_50 = { class: "customer-data-value" }
const _hoisted_51 = { class: "customer-block" }
const _hoisted_52 = { class: "customer-block-header" }
const _hoisted_53 = { class: "customer-data-row-general" }
const _hoisted_54 = { class: "general-data" }
const _hoisted_55 = { class: "customer-data-title" }
const _hoisted_56 = {
  key: 1,
  class: "customer-data-value"
}
const _hoisted_57 = { class: "general-data" }
const _hoisted_58 = { class: "customer-data-title" }
const _hoisted_59 = {
  key: 1,
  class: "customer-data-value"
}
const _hoisted_60 = { class: "general-data" }
const _hoisted_61 = { class: "customer-data-title" }
const _hoisted_62 = {
  key: 1,
  class: "customer-data-value"
}
const _hoisted_63 = { class: "customer-block-view-footer" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-back fs-10" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewHeader = _resolveComponent("ViewHeader")!
  const _component_DropdownInput = _resolveComponent("DropdownInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ViewHeader, {
      text: `Order #${_ctx.orderInStore.orderNumber} ${_ctx.orderInStore.customer?.groupName == undefined || _ctx.orderInStore.customer?.groupName == '' ? '' : _ctx.orderInStore.customer?.groupName + '-'}${_ctx.orderInStore.customer.firstName + ' ' + _ctx.orderInStore.customer.lastName}`
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.customer-details")), 1),
          _createElementVNode("span", null, [
            (!_ctx.editCustomerMode)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: "icon-f icon-pencil fs-22",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setEditCustomerMode(true)))
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args))),
                    class: "save-link",
                    href: "#"
                  }, _toDisplayString(_ctx.$t("cashier.label.save")), 1),
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelChanges && _ctx.cancelChanges(...args))),
                    class: "cancel-link",
                    href: "#"
                  }, _toDisplayString(_ctx.$t("cashier.label.cancel-changes")), 1)
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("cashier.label.first-name")) + ": ", 1),
            (_ctx.editCustomerMode)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderInStore.customer.firstName) = $event)),
                  maxlength: "255"
                }, null, 512)), [
                  [_vModelText, _ctx.orderInStore.customer.firstName]
                ])
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.orderInStore.customer.firstName), 1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("cashier.label.mobile")) + ": ", 1),
            (_ctx.editCustomerMode)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderInStore.customer.mobile) = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.orderInStore.customer.mobile]
                ])
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.orderInStore.customer.mobile), 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("cashier.label.last-name")) + ": ", 1),
            (_ctx.editCustomerMode)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  maxlength: "255",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderInStore.customer.lastName) = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.orderInStore.customer.lastName]
                ])
              : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.orderInStore.customer.lastName), 1))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("cashier.label.email")) + ": ", 1),
            (_ctx.editCustomerMode)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.orderInStore.customer.email) = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.orderInStore.customer.email]
                ])
              : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.orderInStore.customer.email), 1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("orders.orderDetails")), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("label.channel")) + ": ", 1),
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.orderInStore.channelName), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("cashier.label.order-status")) + " ", 1),
              _createElementVNode("span", {
                class: "status",
                style: _normalizeStyle({ color: _ctx.OrderStatusColors[_ctx.orderInStore.status] })
              }, _toDisplayString(_ctx.orderInStore.statusName), 5)
            ]),
            (_ctx.orderInStore.status == _ctx.OrderStatus.OK)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "cancel-link",
                  href: "#",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancelOrder(_ctx.orderInStore.id)))
                }, _toDisplayString(_ctx.$t("orderActions.cancelOrder")), 1))
              : (_ctx.orderInStore.status == _ctx.OrderStatus.RQ)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    style: {"font-size":"16px","-webkit-text-decoration-line":"underline","text-decoration-line":"underline","color":"green"},
                    href: "#",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.trySetOkStatus(_ctx.orderInStore.id)))
                  }, _toDisplayString(_ctx.$t('label.book-order')), 1))
                : (_ctx.orderInStore.status == _ctx.OrderStatus.CN)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      style: {"font-size":"16px","-webkit-text-decoration-line":"underline","text-decoration-line":"underline","color":"green"},
                      href: "#",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.trySetOkStatus(_ctx.orderInStore.id)))
                    }, _toDisplayString(_ctx.$t('label.rebook-order')), 1))
                  : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("label.order-client-type")) + " ", 1),
            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.orderInStore.priceTypeName), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("order.arrivalConfirmation.title")) + ": ", 1),
            (_ctx.orderInStore.arrivalConfirmation === 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.arrivalConfirmation())),
                  class: "order-modify-button-wrapper",
                  style: {"background":"linear-gradient(180deg, #62a1c9 0%, #598eb4 100%)","color":"#ffffff"}
                }, _toDisplayString(_ctx.$t("order.arrivalConfirmation.none")), 1))
              : _createCommentVNode("", true),
            (_ctx.orderInStore.arrivalConfirmation === 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.arrivalConfirmation())),
                  class: "arrival-btn",
                  style: {"background-color":"#fd695a","color":"#ffffff"}
                }, _toDisplayString(_ctx.$t("order.arrivalConfirmation.notArrived")), 1))
              : _createCommentVNode("", true),
            (_ctx.orderInStore.arrivalConfirmation === 2)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.arrivalConfirmation())),
                  class: "arrival-btn",
                  style: {"background-color":"#f6ae28","color":"#ffffff"}
                }, _toDisplayString(_ctx.$t("order.arrivalConfirmation.arrivedPartially")), 1))
              : _createCommentVNode("", true),
            (_ctx.orderInStore.arrivalConfirmation === 3)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  type: "button",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.arrivalConfirmation())),
                  class: "arrival-btn",
                  style: {"background-color":"#79d217","color":"#ffffff"}
                }, _toDisplayString(_ctx.$t("order.arrivalConfirmation.arrived")), 1))
              : _createCommentVNode("", true),
            (_ctx.showArrivalConfirmationPoppup)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("order.hasCustomerArrived")), 1),
                  _createElementVNode("span", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showArrivalConfirmationPoppup = false)),
                    class: "icon-f closeArrivalConfirmationPoppup icon-delete-cross fs-12"
                  }),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("button", {
                      class: "arrived",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onClockArrivalConfirmation(3)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t("order.arrivalConfirmation.arrived")) + " ", 1),
                      _hoisted_37
                    ]),
                    _createElementVNode("button", {
                      class: "notArrived",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onClockArrivalConfirmation(1)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t("order.arrivalConfirmation.notArrived")) + " ", 1),
                      _hoisted_38
                    ]),
                    _createElementVNode("button", {
                      class: "arrivedPartially",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onClockArrivalConfirmation(2)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t("order.arrivalConfirmation.arrivedPartially")) + " ", 1),
                      _hoisted_39
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("a", {
            class: "generate-link",
            href: "#",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getOrderLinkUrl(_ctx.orderInStore.id)))
          }, _toDisplayString(_ctx.$t('orderActions.getLink')), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("label.order-created-date")) + " ", 1),
            _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.getOrderCreateDate(_ctx.orderInStore.createDate)), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("cashier.label.printed-status")) + " ", 1),
            _hoisted_46
          ])
        ]),
        (_ctx.orderInStore.businessClient)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("label.business-client-name")) + " ", 1),
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.orderInStore.businessClient.name), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.general")), 1)
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("cashier.label.remarks")) + ":", 1),
            (_ctx.editCustomerMode)
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 0,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.orderInStore.customer.remarks) = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.orderInStore.customer.remarks]
                ])
              : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.orderInStore.customer.remarks), 1))
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t("cashier.label.source")) + ":", 1),
            (_ctx.editCustomerMode)
              ? (_openBlock(), _createBlock(_component_DropdownInput, {
                  key: 0,
                  options: _ctx.orderSourceOptions,
                  optionLabel: "text",
                  optionValue: "id",
                  placeholder: _ctx.$t('cashier.placeholder.select-order-source'),
                  modelValue: _ctx.orderInStore.sourceOptionId,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.orderInStore.sourceOptionId) = $event)),
                  showClearProp: true
                }, null, 8, ["options", "placeholder", "modelValue"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.getOrderSourceOptionName(_ctx.orderInStore.sourceOptionId)), 1))
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("cashier.label.ext-sys-number")) + ":", 1),
            (_ctx.editCustomerMode)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  style: {"text-indent":"10px"},
                  type: "text",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.orderInStore.customer.pnr) = $event)),
                  maxlength: "255"
                }, null, 512)), [
                  [_vModelText, _ctx.orderInStore.customer.pnr]
                ])
              : (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.orderInStore.customer.pnr), 1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("button", {
        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.backToResults && _ctx.backToResults(...args)))
      }, [
        _hoisted_64,
        _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.back-to-results")), 1)
      ])
    ])
  ]))
}